import { useEffect, useState } from "react";
import { postData } from "./Http/api";

const CasoEventoTipo = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await postData("/CasoEventoTipoListar", {});

        const data = response.value.map((item) => ({
          idCasoEventoTipo: item.idCasoEventoTipo,
          descripcion: item.descripcion,
          activo: item.activo,
          vuelveAProponerse: item.vuelveAProponerse,
          diasEspera: item.diasEspera,
          diasEsperaEfectivos: item.diasEsperaEfectivos
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Tipos de Evento:", ex);
        setRows([]);
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchCasoEventoTipos = async (idCasoEstado = 0) => {
  try {
    const response = await postData("/CasoEventoTipoListar", { idCasoEstado: idCasoEstado, activo: 1 });
    return (response?.value || []).map((item) => ({
      idCasoEventoTipo: item.idCasoEventoTipo,
      descripcion: item.descripcion,
      activo: item.activo,
      // Disparador (3.2d): si el caso vuelve a proponerse con este evento y en cuántos días.
      vuelveAProponerse: item.vuelveAProponerse,
      diasEsperaEfectivos: item.diasEsperaEfectivos,
    }));
  } catch (ex) {
    console.error("Error cargando Tipos de Evento (helper):", ex);
    return [];
  }
};

export default CasoEventoTipo;
